interface LogoProps {
  className?: string;
  size?: number;
}

export default function Logo({ className = '', size = 200 }: LogoProps) {
  const width = size;
  const height = size * 0.45;

  return (
    <svg
      viewBox="0 0 240 108"
      width={width}
      height={height}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Pill shape border */}
      <rect
        x="4"
        y="4"
        width="232"
        height="100"
        rx="50"
        ry="50"
        fill="none"
        stroke="white"
        strokeWidth="3"
      />

      {/* Air Jordan text */}
      <text
        x="120"
        y="40"
        textAnchor="middle"
        fill="white"
        fontFamily="Arial, sans-serif"
        fontWeight="bold"
        fontSize="20"
        letterSpacing="3"
      >
        AIR JORDAN
      </text>

      {/* 360 text - larger */}
      <text
        x="120"
        y="82"
        textAnchor="middle"
        fill="white"
        fontFamily="Arial, sans-serif"
        fontWeight="bold"
        fontSize="40"
        letterSpacing="6"
      >
        360
      </text>
    </svg>
  );
}
